// MESSAGE API
import Request from '../base'
export default {
  save (options) {
    return Request.post('/ebermessage/messageapi/notice/message/save', options)
  },
  delete (options) {
    return Request.post('/ebermessage/messageapi/notice/message/delete', options)
  },
  load (options) {
    return Request.post('/ebermessage/messageapi/notice/message/load', options)
  },
  read (options) {
    return Request.post('/ebermessage/messageapi/notice/message/read', options)
  },
  list (options) {
    return Request.post('/ebermessage/messageapi/notice/message/list', options)
  },
  count (options) {
    return Request.post('/ebermessage/messageapi/notice/message/count', options)
  },
  find (pagination, options) {
    if (!pagination.sort) {
      pagination.sort = 'time'
    }
    if (!pagination.order) {
      pagination.order = 'DESC'
    }
    return Request.post('/ebermessage/messageapi/notice/message/find', Request.paginationBody(options, pagination))
  }
}
